import { render, staticRenderFns } from "./merchant-user-setting.vue?vue&type=template&id=56511c9d&scoped=true"
import script from "./merchant-user-setting.vue?vue&type=script&lang=js"
export * from "./merchant-user-setting.vue?vue&type=script&lang=js"
import style0 from "./merchant-user-setting.vue?vue&type=style&index=0&id=56511c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56511c9d",
  null
  
)

export default component.exports